import { AUTHORIZATION_MODULE_PATH } from '@/store/modules/authorization';

export default (store, func) => {
  let registered = false;
  store.dispatch('boilerplate/addDelayedModule', 'dashboardPem');

  store.subscribe((mutation) => {
    if (
      !registered &&
      mutation.type === 'RouteModule/ROUTE_CHANGED' &&
      mutation.payload.to.fullPath === '/dashboardPem'
    ) {
      func();
      registered = true;
      store.dispatch('boilerplate/setLoading', null);
      store.dispatch('boilerplate/removeDelayedModule', 'dashboardPem');
    }
  });
  store.subscribeAction((action) => {
    if (action.type === `${AUTHORIZATION_MODULE_PATH}/setAuthorizations`) {
      if (
        (!registered && action.payload.isPEM) ||
        store.getters['RouteModule/path'] === 'dashboardPem'
      ) {
        func();
        registered = true;
        store.dispatch('boilerplate/removeDelayedModule', 'dashboardPem');
      }
    }
  });
};
